import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { faAngleDown, faChevronRight, faPaintBrush, faPallet, faTrash } from '@fortawesome/free-solid-svg-icons';
import { CryptoService } from 'src/app/services/crypto/crypto.service';
import { FilesService } from 'src/app/services/files/files.service';
import { NotificationService } from 'src/app/services/notification/notification.service';
import { ProfileService } from 'src/app/services/profile/profile.service';
import { mspFileInterface } from 'src/app/util/interfaces/mspFile';
import { styleSheetInterface } from 'src/app/util/interfaces/styleSheet';
import { LabelsService } from 'src/app/util/services/labels/labels.service';
import { StylesheetService } from './service/stylesheet.service';
import { iacOptionInterface } from 'src/app/page_component_item/input-with-autocomplete/input-with-autocomplete.component';
import { mspTableHeaderI } from 'src/app/page_component_item/msp-table/msp-table.component';
import { LabelsInterface } from 'src/app/util/services/labels/data/label.inteface';

@Component({
	selector: 'register-form-stylesheet',
	templateUrl: './stylesheet.component.html',
	styleUrls: ['./stylesheet.component.scss'],
})
export class StylesheetComponent implements OnInit, OnDestroy {
	icons = {
		faAngleDown: faAngleDown,
		faTrash: faTrash,
		faPaintBrush: faPaintBrush,
	};

	labels: LabelsInterface = {
		lbl_geral_avancado: 'Advanced',
		lbl_geral_cor_principal: 'Main color',
		lbl_geral_cor_secundaria: 'Secondary color',
		lbl_cor_ternaria: 'Ternary color',
		lbl_geral_visualizar: 'Visualize',
		lbl_geral_registrar: 'Register',
		lbl_nome_da_paleta_de_cor: 'Name of color pallet',
		lbl_nao_deixe_em_branco: 'Do not leave the primary or secondary color white',
		lbl_clique_em_qualquer_lugar_para_voltar: 'Click anywhere on the screen to return to the original',
		lbl_geral_atualizar: 'Update',
		lbl_geral_voltar: 'Back',
		lbl_geral_excluir: 'Delete',
		lbl_geral_inserir_novo: 'Insert new',
		lbl_selecione_um_estilo: 'Select a Style',
		lbl_geral_criado_com_sucesso: 'Successfully created',
		lbl_successful_updated: 'Successful updated',
		lbl_geral_deletado_com_sucesso: 'Successful deleted',
		lbl_catalogo_incompleto: 'This catalog is incomplete, if you think this should not happen, please contact your mySupport team',
		lbl_preencha_todos_asteriscos: 'Fill in at least the fields marked by *',
		lbl_logo: 'Logo',
		lbl_geral_logo_requerimentos:
			'An image with a maximum width of 300 and a height of 300 is required, in one of the formats: JPEG, PNG or JPG, and with a size limit of 1MB',
		lbl_logo_medidas: 'Check the image measurements (max: 300x300)',
		lbl_logo_tipo: 'Make sure the image type is PNG, JPG or JPEG',
		lbl_logo_size: 'Check image size, max 1mb',
		lbl_geral_anexar_arquivo: 'Attach',
		lbl_remover_anexo: 'Remove attachment',
		lbl_geral_estilos: '',
		lbl_geral_buscar: '',
		lbl_geral_limpar_campos: '',
		lbl_formato_invalido_ou_corrompido: '',
		lbl_limite_tamanho_excedido: '',
		lbl_cores_avancadas: '',
		lbl_geral_nomes_arquivos_caracteres_especiais: '',
		'lbl_nenhum_§placeholder§_cadastrado': '',
		lbl_geral_tema: '',
		lbl_geral_temas: '',
	};

	searchHeader: mspTableHeaderI[] = [{ name: 'name', value: 'lbl_color_pallet', colType: 'text' }];

	constructor(
		private ProfileService: ProfileService,
		private NotificationService: NotificationService,
		private LabelsService: LabelsService,
		private StylesheetService: StylesheetService,
		private FilesService: FilesService,
		private CryptoService: CryptoService
	) {}

	isLoadingLabels = true;
	isLoadingStylesheet = true;

	isLoadingStylesheetData = false;
	isCrudingStylesheet = false;

	stylesheetArr: styleSheetInterface[] = [];
	stylesheet: styleSheetInterface = {
		id: undefined,
		default: false,
		name: '',
		'primary-color-1': '#0073e6',
		'primary-color-1-dark-mode': '#3dc7ff',
		'primary-color-2': '#00005c',
		'primary-color-2-dark-mode': '#3dc7ff',
		app_source: 'msp',
		logo: {
			content: '',
			checkSum: '',
			extension: ''.toLowerCase(),
			file_path: '',
			mimeType: '',
			name: '',
			size: 0,
		},
	};

	//This is the current user stylesheet to return after the visualizing function
	stylesheetInUse: styleSheetInterface = {} as styleSheetInterface;

	isVisualizingNewStylesheet = false;

	ngOnInit(): void {
		this.LabelsService.getLabels().subscribe((labels) => {
			this.labels = labels;
			this.isLoadingLabels = false;
		});

		this.ProfileService.getStyleSheetList(true)
			.subscribe({
				next: (stylesheetArray) => {
					this.stylesheetArr = stylesheetArray;
				},
			})
			.add(() => {
				this.isLoadingStylesheet = false;
			});

		const root = document.documentElement;
		this.stylesheetInUse['primary-color-1'] = root.style.getPropertyValue('--primary-color-1');
		this.stylesheetInUse['primary-color-1-light'] = root.style.getPropertyValue('--primary-color-1-light');
		this.stylesheetInUse['primary-color-2'] = root.style.getPropertyValue('--primary-color-2');
		this.stylesheetInUse['primary-color-2-light'] = root.style.getPropertyValue('--primary-color-2-light');
	}

	ngOnDestroy(): void {
		this.returnOriginalStylesheet();
	}

	resetStylesheet(): void {
		this.stylesheet = {
			id: '',
			name: '',
			default: false,
			'primary-color-1': '#0073e6',
			'primary-color-1-dark-mode': '#3dc7ff',
			'primary-color-2': '#00005c',
			'primary-color-2-dark-mode': '#3dc7ff',
			app_source: 'msp',
			logo: {
				content: '',
				checkSum: '',
				extension: '',
				file_path: '',
				mimeType: '',
				name: '',
				size: 0,
			},
		};
	}

	visualizeStylesheet(): void {
		const root = document.documentElement;

		root.style.removeProperty(`--primary-color-1`);
		root.style.removeProperty(`--primary-color-2`);
		root.style.removeProperty(`--primary-color-3`);

		root.style.setProperty(`--primary-color-1`, this.stylesheet['primary-color-1']);
		root.style.setProperty(`--primary-color-2`, this.stylesheet['primary-color-2']);

		// this.NotificationService.setNotificationMessage(this.labels.lbl_clique_em_qualquer_lugar_para_voltar);
		this.isVisualizingNewStylesheet = true;
	}

	returnOriginalStylesheet(): void {
		const root = document.documentElement;

		root.style.removeProperty(`--primary-color-1`);
		root.style.removeProperty(`--primary-color-2`);
		root.style.removeProperty(`--primary-color-3`);

		root.style.setProperty(`--primary-color-1`, this.stylesheetInUse['primary-color-1']);
		root.style.setProperty(`--primary-color-1-light`, this.stylesheetInUse['primary-color-1-light']);
		root.style.setProperty(`--primary-color-2`, this.stylesheetInUse['primary-color-2']);
		root.style.setProperty(`--primary-color-2-light`, this.stylesheetInUse['primary-color-2-light']);

		this.isVisualizingNewStylesheet = false;
	}

	submitStylesheet(): void {
		if (this.isCrudingStylesheet) return;

		this.isCrudingStylesheet = true;

		if (this.stylesheet.name == '') {
			this.NotificationService.setNotificationMessage(this.labels.lbl_preencha_todos_asteriscos);
		} else {
			this.StylesheetService.createStylesheet(this.stylesheet)
				.subscribe({
					next: (stylesheetRes) => {
						this.stylesheet.id = stylesheetRes.data.id;
						this.NotificationService.setNotificationMessage(this.labels.lbl_geral_criado_com_sucesso);
						this.stylesheetArr.push(JSON.parse(JSON.stringify(this.stylesheet)));
					},
				})
				.add(() => {
					this.isCrudingStylesheet = false;
				});
		}
	}

	getStylesheetById(idStylesheet: string): void {
		if (this.isLoadingStylesheetData) return;

		this.isLoadingStylesheetData = true;
		this.StylesheetService.getStyleSheetData(idStylesheet)
			.subscribe({
				next: (stylesheetData) => {
					this.stylesheet = stylesheetData;
				},
			})
			.add(() => {
				this.isLoadingStylesheetData = false;
			});
	}

	updateStylesheet(): void {
		if (this.isCrudingStylesheet) return;

		this.isCrudingStylesheet = true;
		this.StylesheetService.updateStylesheet(this.stylesheet)
			.subscribe({
				next: () => {
					if (this.stylesheet.id === this.ProfileService.userData().css_pattern) {
						location.reload();
					}
					this.NotificationService.setNotificationMessage(this.labels.lbl_successful_updated);
				},
			})
			.add(() => {
				this.isCrudingStylesheet = false;
			});
	}

	deleteStylesheet(stylesheetId?: string): void {
		if (this.isCrudingStylesheet) return;

		this.isCrudingStylesheet = true;
		this.StylesheetService.deleteStylesheet(stylesheetId ? stylesheetId : this.stylesheet.id)
			.subscribe({
				next: () => {
					if ((stylesheetId ? stylesheetId : this.stylesheet.id) === this.ProfileService.userData().css_pattern) {
						location.reload();
					}

					this.NotificationService.setNotificationMessage(this.labels.lbl_geral_deletado_com_sucesso);
				},
			})
			.add(() => {
				this.isCrudingStylesheet = false;
			});
	}

	handleFileLog(): void {
		const logoFile = (<HTMLInputElement>document.querySelector('#stylesheetLogo')).files[0];

		if (!this.FilesService.nameAllowed(logoFile)) {
			return this.NotificationService.setNotificationMessage(this.labels.lbl_geral_nomes_arquivos_caracteres_especiais);
		}

		if (logoFile) {
			this.FilesService.MSPFileFromFile(logoFile).then((mspFile) => {
				if (mspFile.mimeType != 'image/jpg' && mspFile.mimeType != 'image/jpeg' && mspFile.mimeType != 'image/png') {
					this.NotificationService.setNotificationMessage(`"${mspFile.name}" ${this.labels.lbl_formato_invalido_ou_corrompido}`);
					return;
				}
				if (Math.floor(mspFile.size / 1_000_000) > 1) {
					this.NotificationService.setNotificationMessage(`"${mspFile.name}" ${this.labels.lbl_limite_tamanho_excedido} (1MB)`);
					return;
				}
				this.stylesheet.logo = mspFile;
			});
		} else {
			this.cleanFileLogo();
		}
	}

	cleanFileLogo(): void {
		this.stylesheet.logo = {
			content: '',
			checkSum: '',
			extension: '',
			file_path: '',
			mimeType: '',
			name: '',
			size: 0,
		};
	}
}
